<span class="caller-activity-info" matTooltipClass="tooltip-class" #circleContainer>
    <!-- <img class="status" src="../../assets/images/{{SECONDARYSTATUS?.isRegistered ? 'greenStatus.jpg' : 'redStatus.png'}}"> -->
    <svg [style.width]="circleSize.l+'px'" [style.height]="circleSize.l+'px'" [matTooltip]="tooltip">
      <circle [attr.cx]="circleSize.cx" [attr.cy]="circleSize.cy" [attr.r]="circleSize.r" [ngStyle]="{
        'fill': color,
        'stroke-width': '2px',
        'stroke': 'var(--greyb80)'
      }" />
    </svg>
  </span>